module.exports = __webpack_public_path__ + "img/1499359493.9b438a18.jpg";